<template>
      <div :class="{foot: true, ar: $i18n.locale ==='AR'}" >
       	<div class="explain">
       	  <div class="foottitle">
            {{ $t('foot.descriptionTitle') }}
       	  </div>
          <!-- 段落分情况显示, 奇奇怪怪的需求均出自PM -->
       	  <div v-if="showParagraph"  class="footcontent" v-html="$t('game.notification')"></div>
       	  <div v-else class="footcontent" v-html="$t('foot.p2')"></div>
          <div v-if="conutry.money === 'KRW'" class="footcontent">{{ $t('game.koPayTips') }}</div>
       	</div>
       	<div class="policy">
          <p>{{ $t('foot.copyright') }}</p>
          <p v-if="isGlobal">
            <a :href="serviceURl">{{ $t('foot.service') }}</a>
            |
            <a :href="policyUrl">{{ $t('foot.policy') }}</a>
          </p>
          <template v-else>
            <p style="margin-bottom: 10px;">
              <a href="https://www.centurygames.com/zh/terms-of-service/">服务条款</a>
              |
              <a href="https://www.centurygames.com/zh/privacy-policy/">隐私政策</a>
            </p>
            <p>网络文化经营许可证：京网文 [2018] 11352-1040 号<br> 京ICP备13035911号-2</p>
          </template>
        </div>
    </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  const localeMap = {
    "EN": '',
    "zh-Hans": 'zh/',
    "zh-Hant": 'zh/',
    KO: 'ko/',
    JA: 'ja/',
  }
  export default {
    props: ['showParagraph'],
    data() {
       return {

       }
    },
    computed: {
      ...mapGetters([
        'isGlobal',
        'conutry'
      ]),
      policyUrl() {
        return `https://www.centurygames.com/${localeMap[this.$i18n.locale] || ''}privacy-policy`
      },
      serviceURl() {
        return `https://www.centurygames.com/${localeMap[this.$i18n.locale] || ''}terms-of-service/`
      }
    },

  }
</script>

<style scoped>
  .foot{
    width: 100%;
    /* margin-top: 1.25rem; */
    overflow: hidden;
  }
  .explain{
    background-color: #293549;
    padding-bottom: 0.9375rem;
  }
  .explain .footcontent{
    position: relative;
    padding: 0 0.9375rem 0 1.5625rem;
    color: #a9adb0;
    font-size: 0.82rem;
    line-height: 1.1rem;
    margin-bottom: 0.9375rem;
  }
  .explain .footcontent:last-child{
    margin-bottom: 0;
  }
  .explain .footcontent::before{
    content: "";
    position: absolute;
    left: 0.9375rem;
    top: 10px;
    transform: translateY(-50%);
    width: 2px;
    height: 2px;
    background-color: #a9adb0;
    border-radius: 50%;
  }
  .foot.ar .explain .footcontent{
    padding: 0 1.5625rem 0 0.9375rem;
  }
  .foot.ar .explain .footcontent::before{
    display: none;
  }
  .foot.ar .explain .footcontent::after{
    content: "";
    position: absolute;
    right: 0.9375rem;
    top: 10px;
    transform: translateY(-50%);
    width: 2px;
    height: 2px;
    background-color: #a9adb0;
    border-radius: 50%;
  }
  .foottitle{
    font-size: 1.3rem;
    padding: 0 0.9375rem;
    line-height: 2.5rem;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "SemiBold";
  }
  .policy{
    color: #FFFFFF;
    padding: 0.625rem 0;
    font-size: 0.75rem;
    line-height: 1.125rem;
    text-align: center;
  }
  .policy a{
    color: #FFFFFF;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/foot.vue